import type { ResolvedFeatureDto } from '@/src/types/featureExperience'
import { isResolvedForced } from '@/src/utils/featureExperienceResolve'

/**
 * True when the user should see rollout UI for this feature (toggle area, cutover banner).
 * Otherwise show nothing — no banner, no copy where the toggle would be.
 *
 * Toggle enablement itself follows **`canToggle`** (and `isResolvedForced`); `reason` is not a substitute.
 *
 * Out of audience when:
 * - Forced resolution (`isResolvedForced`) — everyone on next; no chrome.
 * - `targetingLevel === "none"` — hierarchical: no tier matched.
 * - `reason === "default"` with `canToggle === false` and `resolvedVersion === "classic"` — not in scope (when BE omits `targetingLevel`).
 *
 * A scheduled **`cutoverDate`** does **not** remove the user from audience — they may still see the toggle when **`canToggle`** is true and a cutover notice (see `NavigationCutoverSessionAlert`).
 */
export function isUserInFeatureRolloutAudience(feature: ResolvedFeatureDto | undefined): boolean {
  if (!feature) {
    return false
  }

  if (isResolvedForced(feature)) {
    return false
  }

  if (feature.targetingLevel === 'none') {
    return false
  }

  if (feature.reason === 'default' && !feature.canToggle && feature.resolvedVersion === 'classic') {
    return false
  }

  return true
}
